import React, { useState } from 'react';
import { usePortfolioStreamedOrSelectedPositionFromOrders } from 'portfolio/store/hooks';
import { useSelectOpenSubmissionsCapsuleStreamData } from 'widgets/openSubmissions/capsule/store/selectors';
import { useWidgetContext } from 'widgets/WidgetContext';
import './OpenSubmissionsCapsuleContent.scss';
import OpenSubmissionsDoughnutChart from 'widgets/openSubmissions/doughnut/OpenSubmissionsDoughnutChart';
import { useOpenSubmissionsData } from 'widgets/openSubmissions/openSubmissionsData';
import { OpenSubmissionCapsuleLabels } from 'widgets/openSubmissions/capsule/OpenSubmissionCapsuleLabels';
import ReactCardFlip from 'react-card-flip';
import { OpenSubmissionsCapsuleBack } from './OpenSubmissionsCapsuleBack';
import { VenueType } from '../../../utils/venueTypeUtils';

export function OpenSubmissionsCapsuleContent() {
    const { widgetKey } = useWidgetContext();
    const streamState = useSelectOpenSubmissionsCapsuleStreamData(widgetKey);
    const selectedPosition = usePortfolioStreamedOrSelectedPositionFromOrders();
    const [flipped, setFlipped] = useState(false);
    const [selectedVenueType, setSelectedVenueType] = useState<
        VenueType | undefined
    >();

    const { chartData, openSubmissionRows } = useOpenSubmissionsData(
        streamState,
        true
    );

    const onClickVenueType = (vt: VenueType) => {
        setFlipped(true);
        setSelectedVenueType(vt);
    };

    return (
        <ReactCardFlip
            isFlipped={selectedVenueType && flipped}
            flipDirection={'vertical'}
        >
            <div className="OpenSubmissionsCapsuleContent">
                <OpenSubmissionsDoughnutChart
                    className="capsule-body"
                    selectedPosition={selectedPosition!}
                    allowHideDoughnut={false}
                    chartData={chartData}
                    doughnutSize={94}
                    hideHelp={true}
                />
                <div className="labels">
                    <OpenSubmissionCapsuleLabels
                        data={openSubmissionRows}
                        onClickVenueType={onClickVenueType}
                    />
                </div>
            </div>
            <OpenSubmissionsCapsuleBack
                data={openSubmissionRows}
                vt={selectedVenueType!}
                onClick={() => setFlipped(false)}
            />
        </ReactCardFlip>
    );
}
